'use strict';

angular.module('internal.inspections')
    .controller('InternalInspectionRelated', ['$scope', '$stateParams', 'IPVisits', 'Resource', 'Cache', function ($scope, $stateParams, IPVisits, Resource, Cache) {
        $scope.resetInspection();
        $scope.months = Resource.months();
        $scope.listParams = {
            currentPage: 0,
            numPerPage: 10
        }
        $scope.serviceID = $stateParams.serviceID;
        
        $scope.getVisits = function (month, year) {
            $scope.loading = true;

            IPVisits.get(false, month, year, $scope.serviceID).then(function (visits) {
                if (month == $scope.month && year == $scope.year) {
                    $scope.visits = visits;
                    $scope.loading = false;
                }
            });
        }

        Cache.getState('list').then(function (state) {
            if (state != null) {
                $scope.sortBy = state.sortBy;
                $scope.reverse = state.reverse;
                $scope.search = state.search;
                $scope.listParams.currentPage = state.currentPage;
                $scope.listParams.numPerPage = state.numPerPage;
                $scope.status = state.status;
                $scope.inspector = state.inspector;
                $scope.month = state.month;
                $scope.year = state.year;
            }
            else {
                $scope.month = new Date().getMonth();
                $scope.year = new Date().getFullYear();
                $scope.listParams.currentPage = 0;
                $scope.listParams.numPerPage = 10;
            }

            $scope.getVisits($scope.month, $scope.year);
        })

        $scope.cacheList = function () {
            var state = {
                sortBy: $scope.sortBy,
                reverse: $scope.reverse,
                search: $scope.search,
                currentPage: $scope.listParams.currentPage,
                numPerPage: $scope.listParams.numPerPage,
                status: $scope.status,
                inspector: $scope.inspector,
                month: $scope.month,
                year: $scope.year
            }

            Cache.setState('list', state);
        }

        $scope.$watch('search + status + inspector + month + year', function (old, newie) {
            if (old != newie) {
                $scope.listParams.currentPage = 0;
                $scope.cacheList();
            }
        });

        $scope.$watch('listParams.currentPage + listParams.numPerPage + sortBy + reverse', function (old, newie) {
            if (old != newie) {
                $scope.cacheList();
            }
        })

        $scope.clear = function () {
            $scope.search = '';
            $scope.listParams.currentPage = 0;
            $scope.status = '';
            $scope.inspector = '';
            $scope.cacheList();
        }
    }])
;